import React from "react";

function Row({ children, gutter = "md", valign = "top" }) {
  return <div className={`row gutter-${gutter} valign-${valign}`}>{children}</div>;
}

export default Row;
